<template>
	<div id="collaborators">
		<div class="vx-row mt-3 mb-6 flex justify-between">
			<div class="vx-col w-full sm:w-1/2 flex justify-center sm:justify-between">
				<h2 class="title-sinao self-center" style="line-height: 35px">{{ $t("Mes collaborateurs") }}</h2>
			</div>

			<div class="w-fit vx-col flex justify-center sm:justify-end">
				<s-button
					icon="icon-plus"
					type="border"
					class="sm:m-base float-none sm:float-right"
					:disabled="loading"
					@click="$router.push({ path: '/collaborators/add', query: $route.query })"
				>
					{{ $t("Ajouter un collaborateur") }}
				</s-button>
			</div>
		</div>

		<div class="mb-4" style="color: #333">
			{{ $t("tooltip collaborateurs") }}
		</div>

		<div class="w-full border-solid border rounded-lg mt-6 overflow-y-auto" style="border-color: var(--border)">
			<table class="w-full border-collapse border-spacing-0">
				<thead class="text-xs bg-grey-light border-b">
					<tr class="border-spacing-0">
						<th class="flex px-4 pt-2 text-md text-left" style="width: 48px">
							<input
								v-model="select_all_checked_model"
								class="w-5 h-5 cursor-pointer"
								type="checkbox"
								@change="toggleAllCollaborators()"
							/>
						</th>
						<th class="px-4 pt-2 text-md text-left w-200">{{ $t("Nom") }}</th>
						<th class="px-4 pt-2 text-md font-semibold text-center">{{ $t("Rôle") }}</th>
						<th class="px-4 pt-2 text-md font-semibold text-center">{{ $t("Entreprises") }}</th>
						<th class="px-4 pt-2 text-md font-semibold text-center">{{ $t("Action") }}</th>
					</tr>

					<tr>
						<th colspan="7">
							<div class="flex pb-2">
								<div
									v-if="selectedCollaborators.length > 0"
									class="flex flex-wrap justify-start items-center mr-8"
									:style="{ width: 'fit-content', gap: '24px' }"
								>
									<button
										class="btn-admin text-sm px-2 flex items-center justify-center"
										:style="{ width: 'fit-content', height: '24px' }"
										@click="openModal"
									>
										{{ $t("Affecter un collaborateur") }}
									</button>

									<button
										class="btn-admin text-sm px-2 flex items-center justify-center"
										:style="{ width: 'fit-content', height: '24px' }"
										@click="deleteCollaborators(selectedCollaborators.map(c => c.id))"
									>
										{{ $t("Supprimer") }}
									</button>
								</div>

								<div
									class="w-fit flex items-center ml-auto whitespace-no-wrap overflow-x-auto"
									:style="{ height: '24px' }"
								></div>
							</div>
						</th>
					</tr>
				</thead>

				<tbody class="w-full">
					<tr v-for="(collaborator, index) in loadedCollaborators" :key="index" class="border-b">
						<td class="px-4 flex" style="padding-top: 8.75px; padding-bottom: 8.75px">
							<input
								type="checkbox"
								class="w-5 h-5 cursor-pointer"
								:checked="isCollaboratorSelected(collaborator)"
								@change="toggleSelection(collaborator)"
							/>
						</td>

						<td class="pr-4 py-1" :style="{ 'max-width': '200px' }">
							<vs-tooltip :text="collaborator.user.email">
								<div class="flex items-center">
									<img
										:src="getImageUrl(collaborator.user)"
										class="rounded-full"
										height="28px"
										width="28px"
										alt="Logo de l'entreprise"
										style="object-fit: contain"
									/>

									<p class="pl-2 text-left text-md truncate">
										{{ collaborator.user.name }}
									</p>
								</div>
							</vs-tooltip>
						</td>

						<td class="text-center px-4" :style="{ width: '145px' }">
							<select
								v-model="collaborator.policy_profile_id"
								class="border-solid border rounded-lg py-1 cursor-pointer"
								:style="{ width: '145px', 'border-color': 'var(--border)' }"
								name="choose_plan"
								@change="updateCollaboratorPolicy(collaborator)"
							>
								<option v-for="(policy, key) in filtered_policies" :key="key" :value="policy.id">
									<span>{{ $t(policy.name) || key }}</span>
								</option>
							</select>
						</td>

						<td class="text-center px-4">
							<div class="flex justify-center items-center">
								<span v-if="collaborator.apps_by_policies.length == 0" class="text-grey text-sm italic">
									{{ $t("Aucune entreprise") }}
								</span>

								<template v-else>
									<vs-tooltip
										v-for="(app, index_app) in collaborator.apps_by_policies.slice(
											0,
											MAX_COLLABORATORS
										)"
										:key="index_app"
										:color="stringToHSLColor(app.name)"
										:text="app.name"
									>
										<div
											class="rounded-full shadow-md text-white uppercase text-lg font-medium"
											:style="{
												'background-color': stringToHSLColor(app.name),
												width: '28px',
												height: '28px',
												'margin-left': '-8px',
												'line-height': '28px'
											}"
										>
											{{ app.name.substring(0, 1) }}
										</div>
									</vs-tooltip>

									<span
										v-if="collaborator.apps_by_policies.length > MAX_COLLABORATORS"
										class="text-grey text-sm italic pl-1"
										:style="{ 'line-height': '28px' }"
									>
										+{{ collaborator.apps_by_policies.length - MAX_COLLABORATORS }}
									</span>
								</template>
							</div>
						</td>

						<td class="text-center px-4">
							<vs-icon
								icon-pack="feather"
								icon="icon-delete"
								size="1.4rem"
								class="cursor-pointer"
								@click="deleteCollaborators(collaborator.id)"
							/>
						</td>
					</tr>

					<tr v-if="loadedCollaborators == null || loadedCollaborators.length == 0">
						<td v-if="is_loading" colspan="6" class="text-center py-4 italic text-grey-light">
							<div ref="cases_loading" class="vs-con-loading__container" />
						</td>

						<td v-else colspan="7" class="text-center py-4 italic text-grey-light">
							{{ $t("Aucun collaborateur trouvé") }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div v-if="selectedCollaborators.length > 0">
			<ModalAssignCollaboratorsToCompanies
				:visible="showModal"
				:app="selectedApp"
				:collaborators="selectedCollaborators"
				:partner-id="user?.partner_id ?? null"
				@close="showModal = false"
				@update="updatedCollaborators"
				@update:visible="val => (showModal = val)"
			/>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapState } from "vuex";
	import ModalAssignCollaboratorsToCompanies from "@/components/ModalAssignCollaboratorsToCompanies.vue";

	export default {
		name: "Collaborators",
		components: { ModalAssignCollaboratorsToCompanies },
		data() {
			return {
				MAX_COLLABORATORS: 10,
				types: ["default", "point", "radius", "corners", "border", "sound", "material"],
				loading: false,
				is_loading: false,
				selectedInvite: null,
				collaboratorPolicies: [],
				selectedCollaborators: [],
				apps: null,
				showModal: false,
				selectedApp: null,
				select_all_checked_model: false // model for select all checkbox
			};
		},
		computed: {
			...mapGetters(["getImageUrl", "sorted_cases", "stringToHSLColor"]),
			...mapState(["user", "pageSize", "partner", "loadedCollaborators", "loadedPolicies", "loadedCases"]),
			filtered_policies() {
				if (!this.loadedPolicies) return [];
				return this.loadedPolicies.filter(policy => !policy.visible && !policy.restricted);
			}
		},
		async mounted() {
			if (this.apps === null) this.apps = await this.$store.dispatch("getApps");
			if (this.loadedPolicies == null) this.$store.dispatch("getPolicies", this.apps[0].id);
		},
		methods: {
			deleteCollaborators(collaboratorId) {
				const ids = Array.isArray(collaboratorId) ? collaboratorId : [collaboratorId];
				const isBatch = ids.length > 1;

				const title = isBatch ? this.$t("Supprimer des collaborateurs") : this.$t("Supprimer un collaborateur");
				const text = isBatch
					? this.$t("Êtes-vous sûr de vouloir supprimer ces collaborateurs ?")
					: this.$t("Êtes-vous sûr de vouloir supprimer ce collaborateur ?");
				const textSuccess = isBatch
					? this.$t("Les collaborateurs ont été supprimés avec succès.")
					: this.$t("Le collaborateur a été supprimé avec succès.");

				this.showConfirmDialog(title, text, () => {
					this.$store.dispatch("deleteCollaborators", { partnerId: this.user?.partner_id, ids }).then(() => {
						this.$vs.notify({
							text: textSuccess,
							color: "success"
						});
						this.$store.dispatch("getCollaborators", { partnerId: this.user?.partner_id });
					});
				});
			},
			showConfirmDialog(title, text, onAccept) {
				this.$vs.dialog({
					type: "confirm",
					title,
					text,
					accept: onAccept,
					cancel: () => {},
					acceptText: this.$t("Oui"),
					cancelText: this.$t("Non")
				});
			},
			isCollaboratorSelected(collaborator) {
				return this.selectedCollaborators.some(item => item.id === collaborator.id);
			},
			toggleSelection(collaborator) {
				this.showModal = false;
				const isSelected = this.selectedCollaborators.some(item => item.id === collaborator.id);
				if (isSelected)
					this.selectedCollaborators = this.selectedCollaborators.filter(item => item.id !== collaborator.id);
				else this.selectedCollaborators.push(collaborator);
			},
			openModal() {
				this.selectedApp = null;
				this.showModal = true;
			},
			updatedCollaborators() {
				this.selectedCollaborators = [];
				this.select_all_checked_model = false;
				this.showModal = false;

				this.$store.dispatch("getPartnerCases", {
					partnerId: this.user?.partner_id,
					pageSize: this.pageSize,
					search: "",
					offset: 0
				});
				this.$store.dispatch("getCollaborators", { partnerId: this.user?.partner_id });
			},
			updateCollaboratorPolicy(collaborator) {
				this.$store.dispatch("updateCollaboratorPolicy", {
					collaboratorId: collaborator.id,
					policyProfileId: collaborator.policy_profile_id,
					partnerId: collaborator.partner_id
				});
			},
			toggleAllCollaborators() {
				if (!this.select_all_checked_model) {
					this.selectedCollaborators = [];
				} else if (this.select_all_checked_model) {
					this.selectedCollaborators = [...this.loadedCollaborators];
				}
			}
		}
	};
</script>

<style scoped>
	.selector_button {
		padding: 0.4rem 0.6rem !important;
	}
</style>
